import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import init from './modules/init';
import mordaLenta from './modules/mordaLenta';
import roulette from './modules/roulette';
import stories from './modules/stories';
import profile from './modules/profile';
import friends from './modules/friends';
import friendsIncoming from './modules/friendsIncoming';
import friendsOutgoing from './modules/friendsOutgoing';
import blacklist from './modules/blacklist';
import messages from './modules/messages';
import threads from './modules/threads';
import guests from './modules/guests';
import albums from './modules/albums';
import videoAlbums from './modules/videoAlbums';
import photos from './modules/photos';
import videos from './modules/videos';
import comments from './modules/comments';
import videoComments from './modules/videoComments';
import puzzles from './modules/puzzles';
import referalCode from './modules/referalCode';
import payment from './modules/payment/payment';
import myPuzzles from './modules/myPuzzles';
import events from './modules/events';
import loader from './modules/loader';
import themes from './modules/themes';
import sockets from './modules/sockets';
import privacy from './modules/privacy';
import balance from './modules/balance';
import eventsBalance from './modules/eventsBalance';
import horoscope from './modules/horoscope';
import infoPages from './modules/infoPages';
import tests from './modules/tests';
import game from './modules/game';
import gifts from './modules/gifts';
import feedback from './modules/feedback';
import home from './modules/home';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        init,
        mordaLenta,
        roulette,
        stories,
        profile,
        friends,
        friendsIncoming,
        friendsOutgoing,
        blacklist,
        messages,
        threads,
        guests,
        albums,
        videoAlbums,
        photos,
        videos,
        comments,
        videoComments,
        puzzles,
        referalCode,
        payment,
        myPuzzles,
        events,
        loader,
        themes,
        sockets,
        privacy,
        balance,
        eventsBalance,
        horoscope,
        infoPages,
        tests,
        game,
        gifts,
        feedback,
        home
    }
});
